(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  
  
  
  
  
document.addEventListener("DOMContentLoaded", function() {

  function miseAJourDecompte() {
    const maintenant = new Date();
    const heureCible = obtenirHeureCible();
    const delta = heureCible - maintenant;

    const heures = Math.floor((delta % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((delta % (1000 * 60 * 60)) / (1000 * 60));
    const secondes = Math.floor((delta % (1000 * 60)) / 1000);
    
    document.getElementById('decompte').textContent = `${heures}h ${minutes}min ${secondes}s`;
  }

  const interval = setInterval(miseAJourDecompte, 1000); // Mise à jour chaque seconde
  miseAJourDecompte(); // Appel initial pour éviter un délai d'une seconde avant l'affichage

});






  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-flydon"] && !window.DesignMode) return;
  try {
    
  
document.addEventListener("DOMContentLoaded", function() {

  function miseAJourDecompte() {
    const maintenant = new Date();
    const heureCible = obtenirHeureCible();
    const delta = heureCible - maintenant;

    const heures = Math.floor((delta % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((delta % (1000 * 60 * 60)) / (1000 * 60));
    const secondes = Math.floor((delta % (1000 * 60)) / 1000);
    
    document.getElementById('decompte').textContent = `${heures}h ${minutes}min ${secondes}s`;
  }

  const interval = setInterval(miseAJourDecompte, 1000); // Mise à jour chaque seconde
  miseAJourDecompte(); // Appel initial pour éviter un délai d'une seconde avant l'affichage

});


  } catch(e) { console.error(e); }
})();
      })();
